//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from "vuex";
import { themeValidation } from "../../../helpers/propsValidators";
import { getButtonCircleTheme } from "../../../helpers";
import { devices } from "~/helpers";

export default {
    name: "BowButton",
    props: {
        bold: {
            default: true,
            type: Boolean,
        },
        color: {
            default: "",
            type: String,
        },
        hollow: {
            default: false,
            type: Boolean,
        },
        href: {
            default: "#",
            type: String,
        },
        icon: {
            default: null,
            type: String,
        },
        rounded: {
            default: null,
            type: [String, Boolean],
        },
        size: {
            default: null,
            type: String,
        },
        theme: {
            default: "primary",
            type: String,
            validation: (value) => themeValidation(value),
        },
        title: {
            default: "",
            type: String,
        },
        type: {
            default: "button",
            type: String,
            // validator: (value) => ['button', 'link', 'link-ext', 'submit'].includes(value)
        },
        uppercase: {
            default: false,
            type: Boolean,
        },
    },
    data: () => ({
        isDesktop: false,
        height: 0,
        initialPosition: {
            bottom: 0,
            left: 0,
            right: 0,
            top: 0,
        },
        width: 0,
    }),
    computed: {
        ...mapState({
            scroll: ({ scroll }) => scroll.scroll,
            isLocomotiveActive: ({ scroll }) => scroll.isLocomotiveActive,
            limit: ({ scroll }) => scroll.limit,
            bounding: ({ scroll }) => scroll.bounding,
            pageHeight: ({ scroll }) => scroll.pageHeight,
        }),

        ...mapGetters([
            "scroll/GET_SCROLL",
            "scroll/GET_IS_LOCOMOTIVE_ACTIVE",
            "scroll/GET_LIMIT",
            "scroll/getBounding",
            "scroll/getPageHeight",
        ]),

        generateClassname() {
            const className = {
                borderRadius: "",
                color: "",
                size: "px-6 py-4",
                theme: "",
                uppercase: "",
                value: "",
            };

            // Manage text color
            if (this.color && this.color !== "") {
                className.color = this.color;
            }

            // Manage size
            // if (this.size) {
            //   if (this.size === 'sm') {
            //     className.size = 'px-5 py-2';
            //   }
            // }

            // Manage uppercase
            if (this.uppercase === true) {
                className.uppercase = "uppercase";
            }

            return [
                "h-12 inline-flex items-center justify-center relative",
                this.bold ? "font-bold" : "",
                className.theme,
                className.size,
                "rounded-button-circle",
                className.uppercase,
            ].join(" ");
        },

        generateAfterClassname() {
            if (typeof window === "undefined") {
                return;
            }

            let theme =
                "after:bg-transparent after:border-2 after:border-solid after:border-primary";

            if (typeof getButtonCircleTheme === typeof Function) {
                theme = getButtonCircleTheme(this.theme);
            }

            const scrollCurrent = this.scroll.current.y;

            return [
                "after:absolute after:h-12 after:left-0 after:pointer-events-none after:rounded-button-circle after:top-0 after:w-12",
                theme,
                "after:transition-[width] after:duration-500",
                "hover:after:w-full",
                this.isDesktop === false && this.isLocomotiveActive === false
                    ? this.scroll.current.y >=
                          this.initialPosition.top -
                              window.innerHeight * 0.75 &&
                      this.scroll.current.y <=
                          this.initialPosition.bottom +
                              window.innerHeight * 0.75
                        ? "after:w-full"
                        : ""
                    : "",
            ].join(" ");
        },
    },

    mounted() {
        this.isDesktop = devices.isDesktop;

        const topPosition = this.$el.getBoundingClientRect().top;
        this.height = this.$el.getBoundingClientRect().height;
        this.width = this.$el.getBoundingClientRect().width;
        this.initialPosition.top = topPosition + this.pageHeight;
        this.initialPosition.bottom = this.initialPosition.top + this.height;
    },
};
